import styled from 'styled-components';
import {colors} from './../tailwind';

export const SortBtn = styled.button`
  height: 33px;
  border-radius: 4px;
  background-color: ${props => (props.selectionMade ? '#00ADEE' : '#ffffff')};
  border: solid 1px #00ADEE;
  font-family: Helvetica;
  font-size: 14px;
  font-weight: ${props => (props.selectionMade ? 'bold' : 'normal')};
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: ${props => (props.selectionMade ? '#414243' : '#595959')};
  padding: 8px 16px;
  margin-right: 16px;
`;

export const SortBtnContainer = styled.div`
  width: 100%;
  height: 64px;
  background-color: #ffffff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.24), 0 0 4px 0 rgba(0, 0, 0, 0.12);
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  position: relative;
  z-index: 2;
`;

export const CatMenu = styled.div`
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.24), 0 0 4px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border: solid 1px #1c6096;
  position: absolute;
  top: 61px;
  z-index: 1;
  padding: 25px 32px 0px 32px;
  display: flex;
  width: 405px;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const SubCatMenu = styled.div`
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.24), 0 0 4px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border: solid 1px #1c6096;
  position: absolute;
  top: 61px;
  left: 123px;
  z-index: 1;
  padding: 25px 32px 0px 32px;
  display: flex;
  width: 405px;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const DateMenu = styled.div`
  width: 405px;
  height: 135px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.24), 0 0 4px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border: solid 1px #1c6096;
  position: absolute;
  top: 61px;
  left: ${props => (props.offset ? props.offset : '267px')};
  z-index: 1;
  padding: 16px;
`;
export const PriceMenu = styled.div`
  width: 258px;
  height: 134px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.24), 0 0 4px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border: solid 1px #1c6096;
  position: absolute;
  top: 61px;
  left: ${props => (props.offset ? props.offset : '352px')};
  z-index: 1;
`;
export const RadiusMenu = styled.div`
  width: 344px;
  height: 134px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.24), 0 0 4px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border: solid 1px #1c6096;
  position: absolute;
  top: 61px;
  left: ${props => (props.offset ? props.offset : '434px')};
  z-index: 1;
`;
export const SortMenu = styled.div`
  width: 242px;
  height: 191px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.24), 0 0 4px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border: solid 1px #1c6096;
  position: absolute;
  top: 61px;
  left: ${props => (props.offset ? props.offset : '527px')};
  z-index: 1;
  padding: 26px 0px 0px 32px;
`;

export const MenuChoice = styled.button`
  font-family: Helvetica;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: ${colors.primary};
  width: 160px;
  cursor: pointer;
  margin-bottom: 25px;
  border: none;
  text-align: left;
`;

export const PriceInput = styled.input`
  width: 79px;
  height: 40px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #6e6f71;
  font-family: Helvetica;
  font-size: 15.4px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: rgba(17, 156, 178, 0.7);
  padding-left: 8px;
`;

export const RangeSlider = styled.input`
  width: 280px;
  height: 4px;
  border-radius: 2px;
  background-color: #d8d8d8;
`;

export const PriceMenuForm = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding: 23px 32px 0px 32px;
`;
export const RadiusMenuForm = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding: 63px 32px 0px 32px;
`;

export const PriceMenuColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputLabel = styled.div`
  margin: 0px 0px 4px 8px;
  font-family: Helvetica;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: #595959;
`;
export const PriceInputBar = styled.div`
  width: 20px;
  height: 4px;
  border-radius: 2px;
  background-color: #00ADEE;
  position: absolute;
  top: 63px;
  left: 119px;
`;

export const ApplyButton = styled.button`
  width: 44px;
  height: 17px;
  font-family: Helvetica;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  text-align: right;
  color: ${colors.primary};
  position: absolute;
  bottom: 16px;
  right: 32px;
  border: none;
`;

export const Miles = styled.div`
  font-family: Helvetica;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: #595959;
  position: absolute;
  top: 24px;
  left: 32px;
`;

export const Text = styled.div`
  font-family: ${props => props.family};
  font-size: ${props => props.size};
  font-weight: ${props => props.weight};
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: ${props => props.color};
  margin: ${({ margin }) => (margin ? margin : '0px')};
`;

export const SortMenuButton = styled.button`
  width: 83px;
  height: 32px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid ${props => (props.selected ? '2px' : '1px')} #6e6f71;
  font-family: Helvetica;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: #595959;
  margin: 8px 16px 16px 0px;
`;

export const ToggleSwitch = styled.img`
  width: 52px;
  height: 32px;
  object-fit: contain;
  position: absolute;
  top: 16px;
  right: 32px;
  cursor: pointer;
  overflow: visible;
`;
export const MapText = styled.div`
  font-family: Helvetica;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: #595959;
  position: absolute;
  top: 23px;
  right: 92px;
`;



// WEBPACK FOOTER //
// ./src/components_new/SortBarComps.js